import { render, staticRenderFns } from "./SvgWrapper.vue?vue&type=template&id=1e58d54c&"
import script from "./SvgWrapper.vue?vue&type=script&lang=js&"
export * from "./SvgWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports